import React from "react";
import { useSelector } from "react-redux";
import { formatePriceFn, formatPrice } from "../../../../helper/commonFunction";

const WalletIco = (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="6" width="18" height="13" rx="2.5" stroke="currentColor" strokeWidth="1.7" />
    <path d="M3 9h18" stroke="currentColor" strokeWidth="1.7" />
    <circle cx="17" cy="13.5" r="1.4" fill="currentColor" />
  </svg>
);
const CardIco = (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="5.5" width="18" height="13" rx="2.5" stroke="currentColor" strokeWidth="1.7" />
    <path d="M3 10h18" stroke="currentColor" strokeWidth="1.7" />
    <path d="M6.5 15h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const Payment = ({
  onContinue,
  setFieldValue,
  selectedMethod,
  error,
  loading,
  errorFromAPI,
  onlinePaymentEnable,
  setError,
  hideButton,
}) => {
  const { walletBalance, agentActiveCurrency, displayPrice } = useSelector((s) => s.userData);

  const pick = (method) => {
    setFieldValue("paymentMethod", method);
    setError && setError(null);
  };

  return (
    <div className="hw-exchk--pay-wrap">
      <div className="hw-exchk--payGrid">
        <button
          type="button"
          className={`hw-exchk--method ${selectedMethod === "wallet" ? "is-selected" : ""}`}
          onClick={() => pick("wallet")}
        >
          <span className="hw-exchk--methodRadio" />
          <span className="hw-exchk--methodIco">{WalletIco}</span>
          <span className="hw-exchk--methodBody">
            <span className="hw-exchk--methodName">Wallet</span>
            <span className="hw-exchk--methodDesc">
              {walletBalance !== null && walletBalance !== undefined ? (
                <>Balance {formatePriceFn(agentActiveCurrency, formatPrice(walletBalance, false, false, true), displayPrice)}</>
              ) : (
                "Pay from your agent wallet"
              )}
            </span>
          </span>
        </button>

        {onlinePaymentEnable ? (
          <button
            type="button"
            className={`hw-exchk--method ${selectedMethod === "online" ? "is-selected" : ""}`}
            onClick={() => pick("online")}
          >
            <span className="hw-exchk--methodRadio" />
            <span className="hw-exchk--methodIco">{CardIco}</span>
            <span className="hw-exchk--methodBody">
              <span className="hw-exchk--methodName">Online Payment</span>
              <span className="hw-exchk--methodDesc">Visa, Mastercard, Amex</span>
            </span>
          </button>
        ) : null}
      </div>

      {error ? <p className="hw-p-error-cls mb-0 mt-2">{error}</p> : null}
      {errorFromAPI ? (
        <div className="hw-p-error-cls mb-0 mt-2" dangerouslySetInnerHTML={{ __html: errorFromAPI }} />
      ) : null}

      {!hideButton ? (
        <div className="mt-6">
          <button
            onClick={async () => {
              if (loading) return;
              onContinue?.();
            }}
            className="hw-btn hw-btn--primary w-100 excursion-book-btn-hide"
          >
            {loading ? (
              <span style={{ minWidth: "2.8rem", minHeight: "2.8rem" }} className="hw-main--loaderCommon" />
            ) : (
              "Pay Now"
            )}
          </button>
        </div>
      ) : null}
    </div>
  );
};
